import { useMutation, useQueryClient } from '@tanstack/react-query'
import { SPEND_CATEGORIES, SPEND_CATEGORY_GROUP_TRANSLATIONS } from 'api/react-query/keys'
import { updateCategoryGroupTranslations } from 'SpendControl/endpoints'
import type { PatchCategoryGroupTranslations } from 'SpendControl/endpoints/spend-control'

type UpdateCategoryGroupTranslationsParams = { id: string } & PatchCategoryGroupTranslations

export const useUpdateCategoryGroupTranslations = () => {
  const client = useQueryClient()

  return useMutation({
    mutationFn: ({ id, ...body }: UpdateCategoryGroupTranslationsParams) => updateCategoryGroupTranslations(id, body),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: [SPEND_CATEGORIES] })
      client.invalidateQueries({ queryKey: [SPEND_CATEGORY_GROUP_TRANSLATIONS] })
    },
  })
}
